export class ReportExplanation {
  id: number;
  name: string;
  explanation: string;
  lastModified: Date;
}